import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import openform from './openform';
import axios from 'axios';
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)
const store = new Vuex.Store({
  state: {
    apiUrl: "https://webapi.piamarket.pl/employees",
    employees: {},
    params: {
      dealer_id: 4
    }
  },
  getters: {
    getEmployees(state) {
      return state.employees;
    }
  },
  actions: {
    fetchEmployees({
      commit,
      state
    }) {
      var t = this;

      axios.get(state.apiUrl, {
          params: state.params
        })
        .then(function(response) {
          commit("setEmployees", response.data.employees)
        })
        .catch(function() {
          window.alert(
            "Błąd pobierania ofert. Sprawdź swoje połączenie z internetem"
          );
        })
    }
  },
  mutations: {
    setEmployees(state, data) {
      return state.employees = data;
    }
  },
  modules: {
    openform
  }
})
export default store;